import { ApiClient } from "./client"

export class OrganisationProvider {
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/organisation/${id}`) as Organisation;
    }

    static async getSubEntityAccessData(id: number) {
        return await this._apiClient.get(`/organisation/${id}/sub-entity-access`) as OrganisationSubEntityAccessData || OrganisationSubEntityNoAccessData;
    }

    static async search(query: string) {
        return await this._apiClient.get(`/organisation/search?query=${encodeURIComponent(query)}`) as Organisation[];
    }

    static async getbyIds(ids: number[]) {
        return await this._apiClient.get(`/organisation/by-ids?${ApiClient.encodeArray(ids, 'id')}`) as Organisation[];
    }

    static async matchByDomains(domains: string[]) {
        return await this._apiClient.get(`/organisation/by-domains?${ApiClient.encodeArray(domains, 'domain')}`) as Organisation[];
    }

    static async save(organisation: Organisation) {
        return await this._apiClient.post('/organisation', organisation) as number;
    }
}

export interface Organisation {
    OrganisationId: number
    OrganisationName: string
    OrganisationDivisionName: string
    OrganisationType: string
    OrganisationStatus: string
    OrganisationAlert: string
    OrganisationImageFileExtension: string
    OrganisationWww: string
    OrganisationTelephone: string
    OrganisationAddress: string
    OrganisationPostCode: string
    OrganisationCity: string
    OrganisationState: string
    OrganisationCounty: string
    OrganisationCountyData: {
        Name: string
        CodeISO: string
        CodeUN: string
    }
    OrganisationUpdatedAt: string
    OrganisationUpdatedBy: string
    OrganisationCreatedAt: string
    OrganisationCreatedBy: string
    [prop: string]: any
}

export interface OrganisationSubEntityAccessData {
    readAllActivities: boolean
    readAllOpportunities: boolean
    readAllDeliveries: boolean
    readAllSupportCases: boolean
}

export const OrganisationSubEntityFullAccessData: OrganisationSubEntityAccessData = {
    readAllActivities: true,
    readAllOpportunities: true,
    readAllDeliveries: true,
    readAllSupportCases: true,
};

export const OrganisationSubEntityNoAccessData: OrganisationSubEntityAccessData = {
    readAllActivities: false,
    readAllOpportunities: false,
    readAllDeliveries: false,
    readAllSupportCases: false,
};